import { render, staticRenderFns } from "./BarChartOrder.vue?vue&type=template&id=2a502d17&scoped=true&"
import script from "./BarChartOrder.vue?vue&type=script&lang=js&"
export * from "./BarChartOrder.vue?vue&type=script&lang=js&"
import style0 from "./BarChartOrder.vue?vue&type=style&index=0&id=2a502d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a502d17",
  null
  
)

export default component.exports